module.exports = __webpack_public_path__ + "static/media/goal.ab7765b9.svg";